import { FormattedMessage } from 'locales/index'
import React from 'react'
import CheckboxInput, { ICheckBoxInputProps } from 'shared/components/common/forms/Checkbox'
import { Typography } from '@commutifi-fe/ui'

function CommutifiTermsCheckbox({
  name,
  tabIndex,
  ...rest
}: Omit<ICheckBoxInputProps, 'children'> & { tabIndex?: number }) {
  return (
    <CheckboxInput name={name || 'agreement'} tabIndex={tabIndex} {...rest}>
      <span>
        <FormattedMessage
          id="components.registerScreen.agreement"
          values={{
            privacyLink: (
              <Typography.Link
                href="http://www.commutifi.com/privacy-policy"
                target="_blank"
                rel="noreferrer"
                tabIndex={tabIndex}
              >
                <FormattedMessage id="components.registerScreen.agreement.link.privacy" />
              </Typography.Link>
            ),
            termsLink: (
              <Typography.Link
                href="http://www.commutifi.com/terms-of-use"
                target="_blank"
                rel="noreferrer"
                tabIndex={tabIndex}
              >
                <FormattedMessage id="components.registerScreen.agreement.link.terms" />
              </Typography.Link>
            )
          }}
        />
      </span>
    </CheckboxInput>
  )
}

export default CommutifiTermsCheckbox
